module.exports = __webpack_public_path__ + "img/hotelFamily-4.e28970db.jpg";